import React from "react";

import withStyles from "@mui/styles/withStyles";
import { colors } from "@zapalacorp/tokens";
import classnames from "classnames";

import { Status, StatusBadgeEnum, UserStatus } from "../../../util/enums";

type Props = {
  value?: string;
  backgroundColor?: string;
  textColor?: string;
  classes?: any;
  className?: string;
  useExternalColor?: boolean;
};

const SimpleBadge = (props: Props) => {
  const { classes, value, className } = props;

  return (
    <div className={classnames(classes.customBadge, className)}>
      <span className={classes.textValue}>{value}</span>
    </div>
  );
};

const StyledBadge = withStyles({
  customBadge: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: (props: { textColor?: string; backgroundColor?: string }) =>
      props?.backgroundColor,
    minWidth: "51px",
    maxWidth: "fit-content",
    padding: "8px 12px",
    height: "28px",
    borderRadius: "20px",
  },
  textValue: {
    fontFamily: "Manrope",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "16px",
    letterSpacing: "0.5px",
    color: (props: { textColor?: string }) => props?.textColor,
    // whiteSpace: "nowrap" as unknown as undefined, // feao isso aqui vei plmds
    whiteSpace: "nowrap",
  },
})(SimpleBadge);

const BadgeStatus = (props: Props) => {
  const { value, className } = props;

  const renderBadge = (backgroundColor: string, textColor: string, value?: string) => {
    if (value)
      return (
        <StyledBadge
          backgroundColor={props?.useExternalColor ? props?.backgroundColor : backgroundColor}
          textColor={props?.useExternalColor ? props?.textColor : textColor}
          value={value}
          className={className}
        />
      );

    return <> </>;
  };

  switch (value?.toLowerCase()) {
    case StatusBadgeEnum.ACTIVE:
    case StatusBadgeEnum.COMPLETED:
      return renderBadge(colors.success50, colors.success600, value);
    case UserStatus.INVITE_EXPIRED.toLowerCase():
    case StatusBadgeEnum.INACTIVE:
    case StatusBadgeEnum.DELETED:
    case StatusBadgeEnum.DISABLED:
      return renderBadge(colors.error50, colors.error600, value);
    case UserStatus.INVITATION_SENT.toLowerCase():
    case Status.PENDING_ACCEPTANCE.toLowerCase():
    case StatusBadgeEnum.PENDING_ACCEPTANCE:
      return renderBadge(colors.warning100, colors.warning500, value);
    case StatusBadgeEnum.PARTLY_LOADED:
    case StatusBadgeEnum.LOADED:
    case StatusBadgeEnum.MFA_ENABLED:
      return renderBadge(colors.success100, colors.success500, value);
    case StatusBadgeEnum.DELIVERED:
      return renderBadge("#eaf5fa", "#38A2CF", value);
    case StatusBadgeEnum.PACKED:
      return renderBadge("#F4EBFF", "#7F56D9", value);
    case StatusBadgeEnum.BOOKED:
      return renderBadge("#eafaf9", "#38CFC4", value);
    case StatusBadgeEnum.RECEIVED:
      return renderBadge("#e7e9fd", "#7E8AF6", value);
    case StatusBadgeEnum.STARTED:
      return renderBadge("#dfe6ec", "#93A9BD", value);
    case StatusBadgeEnum.UNLOADED:
      return renderBadge("#ffede6", "#FFAA86", value);
    case StatusBadgeEnum.LATE:
      return renderBadge("#faebeb", "#CF4842", value);
    case StatusBadgeEnum.FINISHED:
      return renderBadge("#fcf8e9", "#E5CA4F", value);
    case StatusBadgeEnum.IN_TRANSIT:
      return renderBadge("#faf1ea", "#CF7738", value);
    case StatusBadgeEnum.IN_PROGRESS:
      return renderBadge("#faf1ea", "#CF7738", value);
    case StatusBadgeEnum.CANCELLED:
      return renderBadge("#faebeb", "#CF4842", value);
    case StatusBadgeEnum.DEACTIVATED:
      return renderBadge("#faebeb", "#CF4842", value);
    case StatusBadgeEnum.REJECTED:
      return renderBadge("#faebeb", "#CF4842", value);
    case StatusBadgeEnum.PLANNED:
      return renderBadge("#eaf5fa", "#308CDB", value);
    case StatusBadgeEnum.DRAFT.toLowerCase():
      return renderBadge("#F2F4F7", "#475467", value);
    default:
      return renderBadge("#e6fffd", "#00D0BD", value);
  }
};

export default BadgeStatus;
